module.exports = __webpack_public_path__ + "img/footer-logo@2x.9983284f.png";